/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Transcript_AriaInputs */



/**
* | output |
* | --- |
* | "Export transcript file" |
*
* @param {File_Export_Transcript_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_transcript_aria = /** @type {((inputs?: File_Export_Transcript_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Transcript_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter un fichier de transcription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transkriptdatei exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta file di trascrizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт файла транскрипта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar archivo de transcripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出转录文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トランスクリプトファイルをエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रांसक्रिप्ट फ़ाइल निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar arquivo de transcrição")
	return /** @type {LocalizedString} */ ("Export transcript file")
});